import React from 'react'
import './IndividualFeedback.css';
import { useLocation } from 'react-router-dom';
const IndividualFeedback = () => {
    const location = useLocation()
    const profileDetails = location.state.profileDetail;

    return (
        <div>
            {profileDetails.map((eachEvent) => (
                <div>
                    <div className="event-information-container">
                        <div className="details-container">
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Event ID</h5>
                                <p className="information-content">{eachEvent?.feedback_event_id?.ID_event}</p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Event rating</h5>
                                <p className="information-content">{eachEvent.event_rating}</p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Organiser Name</h5>
                                <p className="information-content">
                                    {eachEvent?.organiser?.firstName}  {eachEvent?.organiser?.lastName}
                                </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Organiser rating</h5>
                                <p className="information-content">
                                    {eachEvent.organiser_rating}
                                </p>
                            </div>
                        </div>
                        <div className="details-container">
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Trip title</h5>
                                <p className="information-content">
                                    {eachEvent?.feedback_event_id?.trip_title}
                                </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Trip Date</h5>
                                <p className="information-content">
                                    {eachEvent?.feedback_event_id?.start_date}
                                </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Trip start location</h5>
                                <p className="information-content">
                                    {eachEvent?.feedback_event_id?.start_location}
                                </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="information-side-top-heading">Destination</h5>
                                <p className="information-content">
                                    {eachEvent?.feedback_event_id?.destination}
                                </p>
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <p className="upcomingsession-text">Review</p>
                    <div className="details-container">
                        <div className="details-content-container">
                            <h5 className="information-side-no">1</h5>
                            <h5 className="information-ID">{eachEvent?.feedback_user_id?.profile_id}</h5>
                            <p className="information-content">{eachEvent?.feedback_user_id?.firstName} {eachEvent?.feedback_user_id?.lastName}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Overall rating</h5>
                            <p className="information-content">{eachEvent?.event_rating}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Organiser rating</h5>
                            <p className="information-content">{eachEvent?.organiser_rating}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Mosted Enjoyed</h5>
                            <p className="information-content"> {eachEvent?.event_review.join(",  ") || 'Null'} </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Areas to improve</h5>
                            <p className="information-content">{eachEvent?.mbt_experience?.join(",  ") || 'Null'}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Organiser review</h5>
                            <p className="information-content">
                                {eachEvent?.organiser_review.join(" ") || 'Null'}
                            </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Suggestions</h5>
                            <p className="information-content">
                                {eachEvent?.suggestions || 'Null'}
                            </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Join more trips </h5>
                            <p className="information-content"> {eachEvent?.join_more_trips || 'Null'}</p>
                        </div>
                    </div>
                    <br></br>
                </div>
            ))}

        </div>
    )
}

export default IndividualFeedback
